import isEnabled from './is-enabled';
import isOnlineStoreBlock from './is-online-store-block';

export default {
  isEnabled,
  isOnlineStoreBlock,
};
